import React, { useEffect, useState, useMemo } from "react";
import { Checkbox, Button, Input, Divider } from "antd";
import type { RenderLine, RenderLineDefault, RenderLineMilestone, RenderLinePay } from "./util"
import { k_renderLineType } from "./util"
import type { CheckboxProps } from 'antd';
import clsx from "clsx";

const CheckboxGroup = Checkbox.Group;

type ValueItemType = number | string
type ValueType = ValueItemType[]
type RenderLineWithIsSelected = RenderLine & { isSelected?: boolean }

interface PopProps {
    list?: RenderLine[],
    value?: ValueType,
    onCheckedChange: (v: ValueType) => void,
}
const LineSelect: React.FC<PopProps> = (props) => {
    const [renderList, setRenderList] = useState<RenderLineWithIsSelected[]>(props.list || []);

    useEffect(() => {
        const newList = props.list?.map(v => {
            return {
                ...v,
                isSelected: props.value?.includes(v.lineID) || false
            }
        }) || [];
        setRenderList(newList)
    }, [props.list, props.value]);
    const onChange = (vals: ValueItemType[]) => {
        // setRenderList((prev) => {
        //     return prev.map(item => {
        //         if (item.lineID === v.lineID) {
        //             return {
        //                 ...item,
        //                 isSelected: !item.isSelected
        //             }
        //         }
        //         return item
        //     })
        // })
        props.onCheckedChange(vals)
    }
    const onClear = () => {
        setRenderList(renderList.map(item => {
            return { ...item, isSelected: false }
        }))
        props.onCheckedChange([])
    }
    const onSelectAll = () => {
        const ids = renderList.map(item => item.lineID)
        setRenderList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: true }
            })
        })
        props.onCheckedChange(ids)
    }
    const checkAll = useMemo(() => {
        if(!props.list || !props.value) {
            return false
        }
        return props.list?.length === props.value?.length
    }, [props.list, props.value])
    const indeterminate = useMemo(() => {
        if(!props.list || !props.value) {
            return false
        }
        return checkAll ? false : props.value?.length > 0 && props.value?.length < props.list?.length;
    }, [checkAll, props.value, props.list])
    const onCheckAllChange: CheckboxProps['onChange'] = (e) => {
        // setCheckedList(e.target.checked ? plainOptions : []);
        if(e.target.checked) {
            onSelectAll()
        } else {
            onClear()
        }
    };
    
    return (
        <div className="box-shadow max-w-md py-2 px-4 rounded-md bg-white">
            <div className="relative mb-2">
                <span className="font-bold text-sm">任务线筛选</span>
            </div>
            {renderList.length > 0 && (
                <>
                    <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                        全选
                    </Checkbox>
                    <Divider size="small" />
                    <div className="max-h-96 overflow-y-auto">
                        <CheckboxGroup value={props.value} onChange={onChange}>
                            {renderList.map((v) => (
                                <div key={v.lineID} className="flex items-start py-1 cursor-pointer hover:bg-gray-100">
                                    <Checkbox checked={v.isSelected} value={v.lineID} />
                                    <div className="ml-2 select-none">{v.lineName}</div>
                                </div>
                            ))}
                        </CheckboxGroup>
                    </div>
                </>
            )}
            {renderList.length === 0 && (
                <div className="py-6 text-xs text-gray-400 text-center">暂无任务线数据</div>
            )}
        </div>
    )
}
export default LineSelect